var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 6.78125V11.375",
    stroke: "#B6BEC9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4457 7.50753V13.4925C18.4457 14.4725 17.9207 15.3825 17.0719 15.8813L11.8744 18.8825C11.0257 19.3725 9.97563 19.3725 9.11813 18.8825L3.92063 15.8813C3.07188 15.3913 2.54688 14.4813 2.54688 13.4925V7.50753C2.54688 6.52753 3.07188 5.61749 3.92063 5.11874L9.11813 2.1175C9.96688 1.6275 11.0169 1.6275 11.8744 2.1175L17.0719 5.11874C17.9207 5.61749 18.4457 6.51878 18.4457 7.50753Z",
    stroke: "#B6BEC9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 14.175V14.2625",
    stroke: "#B6BEC9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/warningIcon.cb5f522d1ca3fd097f382786cf070a64.svg";
export { ForwardRef as ReactComponent };